import React from 'react';
import {formsStore} from '../../Form/stores/FormsStore';
import {FormSearch} from './FormSearch';
import {getServerTexts} from '../../../features/PartModal/texts';

const dropdownRef: React.RefObject<typeof FormSearch> = React.createRef();

export async function renderSearch(root, props) {
    const key = `${formsStore.currentForm && formsStore.currentForm.name}_${props.fieldNum}_${
        props.row
    }`;

    //get text for parts modal because parts modal is not render via GWT
    await getServerTexts();
    root.render(<FormSearch ref={dropdownRef} key={key} {...props} />);

    return dropdownRef;
}
